import {
  GET_RIGHT_NAVIGATION,
  // GET_THEME,
  GET_CLIENT_DOCUMENTS,
  GET_CLIENT_PAGES,
  SET_CLIENT_LOADING,
  GET_GLOSSARY,
  GET_LOGO,
  SET_CLIENT_PAGES_LOADING,
  GET_LEVEL_ONES,
  GET_LEVEL_TWOS,
  GET_LEVEL_THREES,
  GET_LEVEL_FOURS,
  GET_STRUCTURE,
  GET_RELATED_CONTENT,
  GET_BOOKMARKS_DOCS,
} from './clientTypes';

const initialState = {
  // structures
  clientName: 'RegulationCity',
  spStructure: null,
  levelOneList: null,
  levelTwoList: null,
  levelThreeList: null,
  levelFourList: null,
  // global styling
  logo: null,
  // theme: null,
  // content
  documents: null,
  pages: null,
  // right nav
  rightNav: null,
  glossaryList: null,
  relatedContent: null,
  flagsList: ['aus', 'fr', 'zh-CN', 'it', 'de', 'el', 'tl', 'hi', 'es'],
  isPreview: false,
  proccessesRunning: 0,
  bookmarksDocs: null,
};

const ClientReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_STRUCTURE:
      return {
        ...state,
        spStructure: action.payload,
        proccessesRunning: state.proccessesRunning - 1,
      };
    case GET_RIGHT_NAVIGATION:
      return {
        ...state,
        rightNav: action.payload,
        proccessesRunning: state.proccessesRunning - 1,
      };
    // not implemented yet
    // case GET_THEME:
    //   return {
    //     ...state,
    //     theme: action.payload,
    //     proccessesRunning: state.proccessesRunning - 1,
    //   };
    case GET_LOGO:
      return {
        ...state,
        logo: action.payload,
        proccessesRunning: state.proccessesRunning - 1,
      };
    case GET_GLOSSARY:
      return {
        ...state,
        glossaryList: action.payload,
        proccessesRunning: state.proccessesRunning - 1,
      };
    case GET_RELATED_CONTENT:
      return {
        ...state,
        relatedContent: action.payload,
        proccessesRunning: state.proccessesRunning - 1,
      };
    case GET_LEVEL_ONES:
      return {
        ...state,
        levelOneList: action.payload,
        proccessesRunning: state.proccessesRunning - 1,
      };
    case GET_LEVEL_TWOS:
      return {
        ...state,
        levelTwoList: action.payload,
        proccessesRunning: state.proccessesRunning - 1,
      };
    case GET_LEVEL_THREES:
      return {
        ...state,
        levelThreeList: action.payload,
        proccessesRunning: state.proccessesRunning - 1,
      };
    case GET_LEVEL_FOURS:
      return {
        ...state,
        levelFourList: action.payload,
        proccessesRunning: state.proccessesRunning - 1,
      };
    case GET_CLIENT_DOCUMENTS:
      return {
        ...state,
        documents: action.payload,
        proccessesRunning: state.proccessesRunning - 1,
      };
    case GET_CLIENT_PAGES:
      return {
        ...state,
        pages: action.payload,
        proccessesRunning: state.proccessesRunning - 100,
      };
    case SET_CLIENT_LOADING:
      return {
        ...state,
        proccessesRunning: state.proccessesRunning + 1,
      };
    case SET_CLIENT_PAGES_LOADING:
      return {
        ...state,
        proccessesRunning: state.proccessesRunning + 100,
      };
    case GET_BOOKMARKS_DOCS:
      return {
        ...state,
        bookmarksDocs: action.payload,
        proccessesRunning: state.proccessesRunning - 1,
      };
    default:
      return state;
  }
};

export default ClientReducer;
